module.exports = __webpack_public_path__ + "components/flag/static/square/ru-f5c8cfe4465afc3e3f872a11930469a2.svg";